import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"
import G from "../../utils/SvgGroup"

const SpotifyIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-5.2 0 28 16.8"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <Path d="m0 0h18v18h-18z" />
      </clipPath>
      <G clip-path="url(#a)">
        <Path
          d="m9 0c-4.97045 0-9 4.02914-9 9 0 4.9709 4.02955 9 9 9 4.9705 0 9-4.0291 9-9 0-4.97086-4.0295-9-9-9zm4.3909 12.974c-.1445.256-.4104.4-.6845.4-.1282 0-.2605-.032-.3819-.0995-1.1236-.63-2.34813-1.016-3.64222-1.147-1.29682-.13-2.57728.0016-3.80728.3944-.41045.131-.85227-.0958-.98318-.5069-.13227-.4118.09545-.8521.50727-.9839 1.43455-.4583 2.93045-.6141 4.44136-.4606 1.50815.1535 2.93725.6035 4.24905 1.3388.3778.2103.5128.6873.3014 1.0647zm1.0773-2.7336c-.1391.2676-.4118.4212-.6941.4212-.1227 0-.2455-.0281-.3614-.0888-1.3813-.71944-2.8732-1.16494-4.43725-1.32366-1.57637-.16132-3.13772-.02073-4.64317.41345-.41591.11809-.84955-.11973-.96818-.5355-.12-.41509.11999-.84873.53453-.96859 1.69909-.48996 3.46091-.64691 5.235-.46691 1.76187.17946 3.44457.68127 5.00317 1.49346.3818.19977.5318.67213.3314 1.05535zm.39-2.27431c-.1173 0-.2359-.02645-.3491-.08209-1.6391-.81736-3.4023-1.32641-5.24183-1.51309-1.84228-.18845-3.675-.04282-5.44909.43091-.41727.11073-.84546-.13677-.95727-.55473-.11182-.41741.13637-.84654.55501-.95795 1.95681-.52255 3.98044-.68168 6.0109-.47523 2.02768.20523 3.97228.76718 5.78048 1.66895.3872.19282.5441.66314.3518 1.0496-.1364.27504-.4132.43363-.7009.43363z"
          fill={color}
        />
      </G>
    </Svg>
  )
}

export default SpotifyIconSvg
